import React, { Component } from "react";
import Window from "../../2/Controls/Window";
import Input from "../../2/Controls/Input";
import Icon from "../../2/Controls/Icon";
import DiscardDialog from "./DiscardDialog";
import { readImageFile } from "./templateUtils";

const NEW_QR = { label: "Scan to pay", mode: "upi", upi: "", name: "", image: "" };

class QrSheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qr: { ...NEW_QR, ...props.qr },
      showDiscard: false,
      error: ""
    };
  }

  isDirty() {
    return (
      JSON.stringify(this.state.qr) !==
      JSON.stringify({ ...NEW_QR, ...this.props.qr })
    );
  }

  update(change) {
    this.setState({ qr: { ...this.state.qr, ...change }, error: "" });
  }

  onClose = () => {
    if (this.isDirty()) {
      this.setState({ showDiscard: true });
    } else {
      this.props.onClose();
    }
  };

  onButtonClick = (button) => {
    if (button === "Remove") {
      this.props.onSave(null);
      return;
    }
    const { qr } = this.state;
    if (qr.mode === "upi" && qr.upi.trim() === "") {
      this.setState({ error: "Please enter your UPI ID" });
      return;
    }
    if (qr.mode === "image" && !qr.image) {
      this.setState({ error: "Please upload your QR image" });
      return;
    }
    this.props.onSave(qr);
  };

  onFileSelected = (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    readImageFile(file, 300, 300)
      .then((image) => this.update({ image }))
      .catch(() => this.setState({ error: "Please choose an image file" }));
  };

  renderSource() {
    const { qr } = this.state;
    if (qr.mode === "upi") {
      return (
        <React.Fragment>
          <Input
            type="text"
            label="UPI ID"
            placeholder="yourstore@upi"
            value={qr.upi}
            onChange={(upi) => this.update({ upi })}
          />
          <Input
            type="text"
            label="Name shown when paying"
            value={qr.name}
            onChange={(name) => this.update({ name })}
          />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        {qr.image && (
          <div className="pt-sign-current">
            <img src={qr.image} alt="QR code" />
            <button type="button" onClick={() => this.update({ image: "" })}>
              Clear
            </button>
          </div>
        )}
        <label className="pt-sign-tile">
          <Icon type="add" />
          Upload QR image
          <input type="file" accept="image/*" onChange={this.onFileSelected} />
        </label>
      </React.Fragment>
    );
  }

  render() {
    const { qr } = this.state;
    return (
      <React.Fragment>
        <Window
          header="QR Code"
          modal={true}
          onClose={this.onClose}
          onButtonClick={this.onButtonClick}
          buttons={[
            ...(this.props.qr
              ? [{ Type: "secondary", Text: "Remove", Align: "left" }]
              : []),
            { Type: "primary", Text: "Save", Align: "right" }
          ]}
        >
          <Input
            type="text"
            label="Label"
            value={qr.label}
            onChange={(label) => this.update({ label })}
          />
          <div className="pt-segment">
            <button
              type="button"
              className={qr.mode === "upi" ? "is-selected" : ""}
              onClick={() => this.update({ mode: "upi" })}
            >
              From UPI ID
            </button>
            <button
              type="button"
              className={qr.mode === "image" ? "is-selected" : ""}
              onClick={() => this.update({ mode: "image" })}
            >
              Upload image
            </button>
          </div>
          {this.renderSource()}
          {this.state.error && <div className="pt-error">{this.state.error}</div>}
        </Window>
        {this.state.showDiscard && (
          <DiscardDialog
            onStay={() => this.setState({ showDiscard: false })}
            onLeave={this.props.onClose}
          />
        )}
      </React.Fragment>
    );
  }
}

export default QrSheet;
